import { useState, useRef, useEffect } from "react";
import { ChevronDown } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";

const langs = [
  { code: "en", label: "EN", name: "English", flag: "gb" },
  { code: "el", label: "EL", name: "Ελληνικά", flag: "gr" },
  { code: "bg", label: "BG", name: "Български", flag: "bg" },
  { code: "ro", label: "RO", name: "Română", flag: "ro" },
];

export const LanguageSwitcher = ({ light = false }) => {
  const { lang, setLang } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const current = langs.find((l) => l.code === lang) || langs[0];

  return (
    <div className="relative" ref={ref}>
      <button
        data-testid="language-switcher"
        onClick={() => setOpen((v) => !v)}
        aria-label="Change language"
        aria-expanded={open}
        className={`flex items-center gap-2 text-sm font-medium transition-colors ${
          light ? "text-[#F4F3EF] hover:text-white" : "text-[#1A1C19] hover:text-[#5C5C59]"
        }`}
      >
        <img
          src={`https://flagcdn.com/w40/${current.flag}.png`}
          alt=""
          className="h-4 w-6 object-cover"
        />
        <span>{current.label}</span>
        <ChevronDown
          size={14}
          className={`transition-transform duration-300 ${open ? "rotate-180" : ""}`}
        />
      </button>

      {open && (
        <div
          data-testid="language-menu"
          className="absolute right-0 mt-3 w-44 bg-[#F4F3EF] border border-stone-300 shadow-[0_10px_40px_-15px_rgba(26,28,25,0.4)] z-[60]"
        >
          {langs.map((l) => (
            <button
              key={l.code}
              data-testid={`lang-option-${l.code}`}
              onClick={() => {
                setLang(l.code);
                setOpen(false);
              }}
              className={`w-full flex items-center gap-3 px-4 py-3 text-sm text-left hover:bg-[#EAE8E3] transition-colors ${
                l.code === lang
                  ? "text-[#1A1C19] font-semibold"
                  : "text-[#5C5C59]"
              }`}
            >
              <img
                src={`https://flagcdn.com/w40/${l.flag}.png`}
                alt=""
                className="h-4 w-6 object-cover"
              />
              {l.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
